export function scrollToElement({
  element,
  offset = 0,
  ignoreHeaderHeight = false,
  behavior = 'smooth',
}: {
  element: HTMLElement
  offset?: number
  ignoreHeaderHeight?: boolean
  behavior?: 'auto' | 'instant' | 'smooth'
}) {
  if (!element) return

  const { top } = element.getBoundingClientRect()
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-height'
    )
  )

  window.scrollTo({
    top:
      top + window.scrollY - (ignoreHeaderHeight ? 0 : headerHeight) + offset,
    behavior,
  })
}
